import { render, staticRenderFns } from "./CompaniesDeliveryTab.vue?vue&type=template&id=4f2bb54a"
import script from "./CompaniesDeliveryTab.vue?vue&type=script&lang=js"
export * from "./CompaniesDeliveryTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports